import React, {Component} from "react";
import './upload-button.css'
import ButtonIcon from "../../button";
import { PDF_Extension, UPLOAD_NOTIFICATION_MESSAGE } from "../../../constants/external-constants";
import { NotificationModal } from "../modal/notification-modal.component";
import Icons from "../../icon";
import { ConfirmationNotificationModal } from "../modal/confirmation-modal.component";
import { CONFIRMATION_VALUE } from "../../../utils/constant.utils";
import { displayFinalFileName } from "../../../utils/helpers.utils";

class UploadButton extends Component {
    constructor(props) {
        super(props);
        this.fileRef = React.createRef();
        this.state = {
            inputValue: "",
            fileList: "",
            fileListData: null,
            pendingUploadFile: null,
            showModal: false,
            showConModal: false,
            showReplaceConModal: false,
            modalMessage: "",
            uploadedFileName: ""
        }
    }

    handleConfirmationModal = () => {
        this.setState(prevState=>({ showModal: !prevState.showModal}));
    }

    handleClearFileName = () => {
        this.setState({
            showConModal:true
        });
    }

    handleConfModal = async (buttonType) => {
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            this.setState({
                inputValue: "",
                fileList: "",
                uploadedFileName: "",
                fileListData: null,
                showConModal: false
            });

            if (this.fileRef.current) {
                this.fileRef.current.value = "";
            }

            if (this.props.onChange) {
                this.props.onChange("");
            }
        }else {
            this.setState({
                showConModal: false
            });
        }
    }

    handleReplaceConfModal = async (buttonType) => {
        if (buttonType === CONFIRMATION_VALUE.Ok && this.state.pendingUploadFile) {
            const { file, filename, finalName } = this.state.pendingUploadFile;

            this.setState({
                uploadedFileName: finalName,
                fileList: finalName,
                fileListData: file,
                pendingUploadFile: null,
                showReplaceConModal: false
            });

            if (this.props.onChange) {
                this.props.onChange(filename);
            }
        } else {
            this.setState({
                pendingUploadFile: null,
                showReplaceConModal: false
            });
        }

        if (this.fileRef.current) {
            this.fileRef.current.value = "";
        }
    }

    handleFileChange = (event) => {
        if (event.target.files && event.target.files.length > 1) {
            this.setState({
                showModal: true,
                modalMessage: "Number of files exceeds the allowable limit of 1"
            });

            event.target.value = "";
            return;
        }

        const file = event.target.files[0];
        if (!file) return;
        const filename = file.name;
        const extIndex = filename.lastIndexOf('.');
        const newName = filename.substring(0, Math.min(extIndex, 20));
        const extension = filename.substring(extIndex + 1);
        const finalName = extIndex > 20 ? `${newName}...${extension}` : filename;
        const maxFileSizeMB = this.props.fileSizeMB || 10;
        const allowedExtensions = (this.props.fileFormat || [PDF_Extension]).map(ext => ext.toUpperCase());

        if (file.size > maxFileSizeMB * 1024 * 1024) {
            this.setState({
                showModal: true,
                modalMessage: `Total file size exceeds the allowable limit of ${maxFileSizeMB} MB`
            });
            event.target.value = "";
            return;
        }

        if (!allowedExtensions.includes(extension.toUpperCase())) {
            this.setState({
                showModal: true,
                modalMessage: `Only files with the following format are allowed: ${allowedExtensions.join(", ")}`
            });
            event.target.value = "";
            return;
        }

        if (this.state.uploadedFileName && this.props.allowReplaceExistingFile) {
            this.setState({
                pendingUploadFile: {
                    file,
                    filename,
                    finalName
                },
                showReplaceConModal: true
            });

            event.target.value = "";
            return;
        }

        this.setState({
            uploadedFileName: finalName,
            fileList: finalName,
            fileListData: file
        });

        if (this.props.onChange) {
            this.props.onChange(filename);
        }
    };

    fileUploadButton = () => {
        const { uploadedFileName } = this.state;
        const { isDisabled, fileFormat } = this.props;
        const acceptAttr = (fileFormat || [PDF_Extension]).map(ext => `.${ext.toLowerCase()}`).join(',');

        if (!uploadedFileName || this.props.allowReplaceExistingFile) {
            return (
                this.props.isReadAndWrite &&
                <ButtonIcon onClick={() => !isDisabled && this.fileRef.current.click()} isDisable={isDisabled} iconLeft="cloud-arrow-up" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Choose File">
                    <input className="upload-file-btn" type="file" ref={this.fileRef} onChange={this.handleFileChange} accept={acceptAttr} disabled={isDisabled} />
                </ButtonIcon>
            );
        }

        return null;
    }


    uploadFileIndicator = () =>{
        const { uploadedFileName } = this.state;
        const { isDisabled } = this.props;

        return (
            <div className={`file-title ${uploadedFileName ? 'attached-file' : ""} ${!this.props.isReadOnly && !isDisabled ? 'pointer' : ''} ${isDisabled ? 'disabled' : ''}`}>
                {uploadedFileName ? (
                    <>
                        <Icons
                            customClassName="icon-file-clip"
                            name="paper-clip-solid"
                            size="15px"
                            containerClass="icon-paper-clip-file-container"
                        />
                        <span onClick={this.props.isReadOnly || isDisabled ? null : this.props.onClickExtract}>{displayFinalFileName(uploadedFileName)}</span>
                        {this.props.isReadAndWrite &&
                            <span className="close-btn" onClick={this.props.isReadOnly || isDisabled ? null : this.handleClearFileName}>x</span>
                        }
                    </>
                ) : "no file selected"}
            </div>
        );
    }

    inputFileValue = () => {
        return this.state.fileListData;
    }

    setUploadFileName(fileName) {
        this.setState({
            inputValue: "",
            fileList: fileName,
            uploadedFileName: fileName,
            fileListData: fileName ? this.state.fileListData : null
        });

        if (!fileName && this.fileRef.current) {
            this.fileRef.current.value = "";
        }
    }

    render() {       
        const { showModal, modalMessage } = this.state;
        const { title, errorModalTitle, clearConfirmationMessage } = this.props;

        return (
            <div className="upload-layout-containers">  
                <div className="upload-button-container">  
                    <span className="title">{title}</span>
                    <div className="upload-button-item">
                            {this.fileUploadButton()}
                            {this.uploadFileIndicator()}
                        </div>
                </div>  
                <ConfirmationNotificationModal
                    show={this.state.showConModal}
                    message={clearConfirmationMessage || UPLOAD_NOTIFICATION_MESSAGE.RemoveFile}
                    title="Confirmation"
                    handleModal={this.handleConfModal}
                    disabled={this.state.isSaving}
                    customClass={'comment-notification-modal modal-text-bold'}
                />
                <ConfirmationNotificationModal
                    show={this.state.showReplaceConModal}
                    message={this.props.replaceConfirmationMessage || "A file is currently uploaded. Uploading another will disregard the current file. Continue?"}
                    title="Confirmation"
                    handleModal={this.handleReplaceConfModal}
                    disabled={this.state.isSaving}
                    customClass={'comment-notification-modal modal-text-bold'}
                />
                <NotificationModal title={errorModalTitle || "Confirmation"} show={showModal} customClass="comment-notification-modal notification-footer" handleModal={this.handleConfirmationModal} message={modalMessage} />
            </div>
        );
    }
}

export default UploadButton;